import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 5px;
`;

export const FormHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
`;

export const StatusOptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusOptionIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const TaskActionsWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;

  @media (max-width: 480px) {
    width: 100%;
    justify-content: flex-start;
  }
`;

export const TaskDetailCardTitle = styled.span`
  font-weight: 700;
  font-size: 16px;
`;

export const TaskIconWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: -10px;
`;

export const TaskDescription = styled.p`
  font-weight: 500;
  font-size: 14px;
  white-space: pre-wrap;
  margin: 0;
`;

export const TaskDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
`;

export const TaskDescriptionTitle = styled.span`
  color: #344054;
  font-weight: 500;
  font-size: 14px;
`;

export const TaskDetailCardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TaskType = styled.span`
  color: #344054;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 5px;
`;

export const DatePickerWrapper = styled.div`
  flex: 1 1 calc(50% - 8px);
  min-width: 0;

  @media (max-width: 480px) {
    flex: 1 1 100%;
  }

  .field {
    width: 100%;
  }
`;

export const TaskFormGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;

  .field,
  .ui.form .field,
  .ui.input,
  .ui.selection.dropdown {
    flex: 1 1 calc(50% - 8px);
    min-width: 0;

    @media (max-width: 480px) {
      flex: 1 1 100%;
    }
  }

  /* Ensure all direct children get flex properties */
  > * {
    flex: 1 1 calc(50% - 8px);
    min-width: 0;

    @media (max-width: 480px) {
      flex: 1 1 100%;
    }
  }
`;

export const TaskDueDateLabel = styled.label`
  display: block;
  margin: 0em 0em 0.28571429rem 0em;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.92857143em;
  font-weight: bold;
  text-transform: none;
`;
